import { useSelector } from "react-redux";
import { useBilling } from "../Kitchen/billingProvider";
import ConfirmModal from "./confirmModal";
import { useState } from "react";
import { useCountry } from "../../provider/courtryProvider";
import { useCustomerData } from "../../provider/billingProviders/customerDataProvider";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { Button } from "antd";
import KotPrintModal from "./kotPrintmodal";
import { useAccess } from "../../provider/AccessProvider";

const GenerateBtn = () => {
  const {
    state: { addedProducts },
  } = useBilling();
  const { getTotalAmount } = useFooterData();
  const total = getTotalAmount();
  const [openModal, setOpenModal] = useState(false);
  const country = useCountry();
  const { customerData } = useCustomerData();
  const [kotModal, setKotModal] = useState(false);
  const shopType = useSelector((state) => state.shopDetails.shopType);
  const access = useAccess(["printKOT"]);

  const validate = () => {
    const customerPhoneNumber = customerData.customerPhoneNumber?.replace(
      country.dialCode,
      ""
    )?.length;
    console.log("customerPhoneNumber111", customerPhoneNumber);
    if (addedProducts.length === 0) {
      alert("Please add product(s) to generate bill.");
      return;
    }
    if (customerData.uniqueId && customerPhoneNumber === 0) {
      return alert("Please enter customer phone number");
    }
    if (
      customerData.uniqueId &&
      customerPhoneNumber.length < country.numberLimit &&
      customerPhoneNumber.length !== country.numberLimit
    ) {
      return alert("Please enter valid phone number");
    }
    if (
      customerData.uniqueId &&
      customerPhoneNumber === country.numberLimit &&
      !customerData.customerName
    ) {
      return alert("Please enter customer name");
    }
    if (customerPhoneNumber && customerPhoneNumber !== country.numberLimit) {
      return alert("Please enter valid phone number");
    }

    if (
      customerPhoneNumber < country.numberLimit &&
      customerPhoneNumber >= 1 &&
      customerPhoneNumber !== country.numberLimit
    ) {
      return alert("Please enter valid phone number");
    }

    if (
      customerPhoneNumber === country.numberLimit &&
      !customerData.customerName
    ) {
      return alert("Please enter customer name");
    }

    if (customerPhoneNumber && customerPhoneNumber !== country.numberLimit) {
      return alert("Please enter valid phone number");
    }

    if (
      customerPhoneNumber < country.numberLimit &&
      customerPhoneNumber >= 1 &&
      customerPhoneNumber !== country.numberLimit
    ) {
      return alert("Please enter valid phone number");
    }
    if (addedProducts.find((o) => o.itemTotal === 0)) {
      return alert("Delete item with Zero value");
    }

    if (addedProducts.find((o) => o.count === 0 || !o.count)) {
      return alert("please add inventory to item with empty qty");
    }
    if (parseFloat(total) < 0) return alert("Total is lesser than Zero.");
    setOpenModal(true);
  };

  const handlePrintKot = () => {
    if (!access.printKOT()) {
      return;
    }
    if (addedProducts?.length <= 0) {
      return alert("Please add product(s) to Create KOT.");
    }
    setKotModal(true);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "10px",
        marginTop: 20,
      }}
    >
      {shopType === "Restaurant" && (
        <Button
          type="primary"
          ghost
          size="large"
          variant="outlined"
          onClick={handlePrintKot}
        >
          Print KOT
        </Button>
      )}
      <button
        className="generatebillBtn"
        onClick={() => {
          validate();
        }}
        style={{
          margin: 0,
        }}
        id="generateBill"
      >
        GENERATE BILL
      </button>
      {openModal && (
        <ConfirmModal
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        />
      )}
      <KotPrintModal open={kotModal} setOpen={setKotModal} />
    </div>
  );
};

export default GenerateBtn;
